import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { $notificationStore } from '../notificationStore';
import { RecipientsApi } from '@shared/api/rest';
import { ApiUtils } from '@shared/utils';
import type { RecipientGetListRequest, RecipientResponse } from '@shared/api/rest/recipients';
import { type IQueryParams, RequestStrategyEnum } from '@shared/api/models';

const effect = createEffect((params: IQueryParams<RecipientGetListRequest>) => RecipientsApi.getList(params.request, params?.signal));
const clearEvent = createEvent();

const $dataStore = createStore<{ total: number; data: RecipientResponse[] }>({
  total: 0,
  data: [],
})
  .on(effect.done, (_, data) => (data.result ? { total: data.result.total, data: data.result.data || [] } : { total: 0, data: [] }))
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(effect.pending, (_, data) => data)
  .on(effect.fail, (_, data) => ApiUtils.abortApiFailCaseTrigger(data))
  .on(effect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(effect, () => null)
  .on(effect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(effect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((x) => {
  ApiUtils.errorStoreAbortRequestWatcher(x, $notificationStore.events.setError);
});

export const $recipientListStore = {
  events: {
    update: ApiUtils.wrapperApi(effect, RequestStrategyEnum.Abort),
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
